import api from '../../../services/api';

const finixService = {
    finalizeOnboarding(payload: FinalizeFinix) {
        return api.post('/finix/finalize', payload, {
          headers: {
            Accept: 'application/json',
            'Content-Type': 'application/json',
          },
        });
      },
      getOnboardingToken(payload: OnboardingLinkFinix)
      {
        return api.post('/finix/onboard', payload, {
            headers: {
              Accept: 'application/json',
              'Content-Type': 'application/json',
            },
          });
      }
}
export default finixService;

export interface FinalizeFinix {
    token: string
    account_id: string
    user_id:number

}
export interface OnboardingLinkFinix {
    user_id: number
}